exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table td[data-v-055ba9d0]{padding:.1rem;vertical-align:middle}.table th[data-v-055ba9d0]{padding:.5rem;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-055ba9d0","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Job/JobAddSpareProductList.vue
// module id = 874
// module chunks = 0